import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'

import { Text } from '@fielded/shared-ui'
import { CheckmarkCircle } from '@fielded/shared-ui/src/icons'

import { formatDate } from '../../utils/utils'

const GoodsTransferProgressInfo = ({
  snapshotsList,
  statusList,
  statusListLabels,
  linksConfig = {}
}) => {
  return (
    <div className='vs-goods-transfer-progress__container'>
      <div className='vs-goods-transfer-progress__wrapper'>
        {statusList.map((status, index) => {
          const previousStatus = statusList[index - 1]
          const nextStatus = statusList[index + 1]

          const isLastStatus = !nextStatus
          const isCompleted = isLastStatus ? !!snapshotsList[status] : !!(nextStatus && snapshotsList[nextStatus])
          const isInProgress = !isCompleted && !!snapshotsList[status]

          const noteConfig = linksConfig[status]
          const shouldShowNote =
          noteConfig &&
          ((noteConfig.displayCondition === 'completed' && isCompleted) ||
            (noteConfig.displayCondition === 'inProgressOrCompleted' &&
              (isCompleted || isInProgress)))

          return (
            <Fragment key={`${status}-${index}`}>
              {!!previousStatus && (
                <div
                  className={classnames(
                    'vs-goods-transfer-progress__transfer-separator',
                    {'vs-goods-transfer-progress__transfer-separator--completed': isCompleted},
                    {'vs-goods-transfer-progress__transfer-separator--in-progress': isInProgress}
                  )}
                />
              )}

              <div className='vs-goods-transfer-progress__transfer-item'>
                <div
                  className={classnames(
                    'vs-goods-transfer-progress__transfer-item-status',
                    {'vs-goods-transfer-progress__transfer-item-status--completed': isCompleted},
                    {'vs-goods-transfer-progress__transfer-item-status--in-progress': isInProgress}
                  )}
                >
                  <span className='vs-goods-transfer-progress__transfer-item-status-icon'>
                    {isCompleted && <CheckmarkCircle />}
                  </span>
                  {statusListLabels[status] || status}
                </div>

                <div className='vs-goods-transfer-progress__transfer-item-info'>
                  {isCompleted && (
                    <Text size='tiny'>
                      {formatDate(snapshotsList[status], 'longWithTime')}
                    </Text>
                  )}

                  {shouldShowNote && (
                    <Link
                      to={noteConfig.path}
                      className='vs-u-link'
                    >
                      {noteConfig.label}
                    </Link>
                  )}
                </div>
              </div>
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default GoodsTransferProgressInfo
